<template>
  <v-list
    style="height: 80vh; overflow-y: auto; display: grid"
    class="players-headline-match-backoffice"
    v-if="loaded"
  >
    <v-flex xs12 md12 class="label" :class="position">
      {{ $t("miccamps.pre.players_starters") }}
    </v-flex>
    <v-flex
      xs12
      md12
      class="player_list"
      :class="position"
      v-for="(player, index) in preFilled.starters"
      :key="player"
    >
      <HlPlayer :player="getPlayer(player)" :position="position"></HlPlayer>
    </v-flex>
    <v-flex xs12 md12 class="label" :class="position">
      {{ $t("miccamps.pre.bench") }}
    </v-flex>
    <v-flex
      xs12
      md12
      class="player_list"
      :class="position"
      v-for="(player, index) in preFilled.no_starters"
      :key="player"
    >
      <HlPlayer :player="getPlayer(player)" :position="position"></HlPlayer>
    </v-flex>
    <v-flex xs12 md12 class="label" :class="position">
      {{ $t("miccamps.pre.no_starters") }}
    </v-flex>
    <v-flex
      xs12
      md12
      class="player_list"
      v-for="(player, index) in preFilled.notlisted"
      :key="player"
      :class="position"
      v-if="parseInt(getPlayer(player).current_sanction) == 0"
    >
      <HlPlayer :player="getPlayer(player)" :position="position"></HlPlayer>
    </v-flex>
    <v-flex xs12 md12 class="label" :class="position">
      {{ $t("miccamps.pre.with_sanction") }}
    </v-flex>
    <v-flex
      xs12
      md12
      class="player_list"
      v-for="(player, index) in preFilled.notlisted"
      :key="player"
      :class="position"
      v-if="parseInt(getPlayer(player).current_sanction) != 0"
    >
      <HlPlayer :player="getPlayer(player)" :position="position"></HlPlayer>
    </v-flex>
  </v-list>
</template>

<script>
import HlPlayer from "@/components/ui/HlPlayer.vue";
export default {
  props: ["team", "preFilled", "position"],
  components: { HlPlayer },
  data: function() {
    return {
      captain: this.preFilled.captain ? this.preFilled.captain : null,
      keepers: this.preFilled.keepers ? this.preFilled.keepers : [],
      starters: this.preFilled.starters ? this.preFilled.starters : [],
      numbers: this.preFilled.numbers ? this.preFilled.numbers : {},
      notlisted: this.preFilled.notlisted ? this.preFilled.notlisted : [],
      loaded: false
    };
  },
  created() {
    this.loaded = true;
  },
  computed: {
    team_starters() {
      let mapped = Object.keys(this.team.players).reduce(
        (previous, current, index) => {
          previous[current] = {
            id: current,
            keeper: this.keepers.includes(current),
            captain: current === this.captain,
            starter: this.starters.includes(current),
            notlisted: this.notlisted.includes(current),
            name: this.team.players[current].name,
            number: this.numbers[current]
              ? this.numbers[current]
              : this.team.players[current].number
          };
          return previous;
        },
        {}
      );
      return mapped;
    },
    filled() {
      return this.preFilled
        ? this.preFilled
        : {
            captain: null
          };
    },
    isKeeper: {
      get() {
        return this.team_starters[this.selectedPlayer.id]
          ? this.team_starters[this.selectedPlayer.id].keeper
          : false;
      },
      set(value) {
        if (value) {
          this.keepers.push(this.selectedPlayer.id);
        } else {
          this.keepers = this.keepers.filter((value, index, arr) => {
            return value !== this.selectedPlayer.id;
          });
        }
      }
    },
    isCaptain: {
      get() {
        return this.team_starters[this.selectedPlayer.id]
          ? this.team_starters[this.selectedPlayer.id].captain
          : false;
      },
      set(value) {
        if (value) {
          this.captain = this.selectedPlayer.id;
        } else {
          this.captain = null;
        }
      }
    },
    number: {
      get() {
        return this.numbers[this.selectedPlayer.id]
          ? this.numbers[this.selectedPlayer.id]
          : this.selectedPlayer.number;
      }
    }
  },
  methods: {
    getPlayer(player_id) {
      var player = this.team.players[player_id];
      if (player) {
        player.is_keeper = this.preFilled.keepers.includes(player_id);
        player.is_captain = this.preFilled.captain == player_id;
        player.number = this.numbers[player_id]
          ? this.numbers[player_id]
          : player.number;
      } else {
      }

      return player;
    }
  }
};
</script>

<style lang="scss" scoped>
.players-headline-match-backoffice {
  height: auto !important;
  .flex {
    height: 25px;
    margin-bottom: 5px;
  }
  .label {
    width: 100% !important;
    &.right {
      text-align: right;
    }
  }
  .item.r {
    text-align: right;
    label {
      right: 0 !important;
    }
  }

  .player_list.r {
    text-align: right;
    background-color: red;
  }
}
</style>
